import { mapGetters } from 'vuex'
import Swiper from '@/components/molecules/Swiper'
import RestaurantCard from '@/components/organism/restaurants/RestaurantCard'
// import store from '@/modules/store'

export default {
    props: {
        restaurants: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        Swiper,
        RestaurantCard,
    },
    data() {
        return {
            type: '',
        }
    },
    computed: {
        ...mapGetters({
            size: 'size',
            restaurantFilters: 'site/restaurantFilters',
            smDevice: 'smDevice',
            mobileDevice: 'mobileDevice',
            locale: 'locale',
        }),
        list() {
            return this.restaurants[this.type] || []
        },
        total() {
            return this.list.length
        },
        loading() {
            return this.restaurants.reload
        },
        filters() {
            return [
                ...Object.keys(this.restaurantFilters || {}),
                ...['already_ordered_from', 'user_favorite', 'tag_name', 'tag_names', 'search'],
            ]
        },
        filterActive() {
            return !!Object.entries(this.$route.query || {}).find(([param, value]) =>
                this.filters.includes(value ? param : undefined)
            )
        },
    },
    watch: {
        loading: {
            immediate: true,
            handler(loading) {
                if (!loading) {
                    this.$store.dispatch('site/listFiltered', this.filterActive)
                }
            },
        },
    },
}
